import { TreeInstance } from '@headless-tree/core';
import React, { useState } from 'react';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list/types';

import { TreeDispatchContext, TreeValueContext } from './context';

type ProviderProps = { children: React.ReactNode };

export const Provider: React.FC<ProviderProps> = ({ children }) => {
  const [tree, setTree] = useState<TreeInstance<InternalTreeItem>>();

  return (
    <TreeDispatchContext.Provider value={setTree}>
      <TreeValueContext.Provider value={tree}>
        {children}
      </TreeValueContext.Provider>
    </TreeDispatchContext.Provider>
  );
};
